<!-- 我的文档分享-文档资料上传 -->
<template>
  <div class="container">
    <div class="title" style="text-align: center;">图片资料上传</div>
    <el-form ref="videoForm"
             class="formBox"
             size="mini"
             :model="form"
             :rules="videoRules"
             label-width="100px"
             label-position="left"
             style="width: 6rem; margin: 0 auto"
    >
      <el-form-item prop="VAttachmentName" style="width: 100%;" label="名称"   >
        <el-input placeholder="请输入" type="text" v-model="form.VAttachmentName" auto-complete="on" name="VAttachmentName"></el-input>
      </el-form-item>

      <el-form-item prop="author"  style="width: 100%;" label="拍摄者">
        <el-input placeholder="请输入" v-model="form.author" auto-complete="on" name="author"></el-input>
      </el-form-item>
      <el-form-item prop="Filmlocations"   style="width: 100%;" label="拍摄日期">
          <el-date-picker v-model="form.Filmlocations" value-format="yyyy-MM-dd" type="date" style="width: 100%;"  placeholder="请选择">
          </el-date-picker>
      </el-form-item>
      <el-form-item prop="place"   style="width: 100%;" label="拍摄地点">
        <el-input placeholder="请输入" v-model="form.place"  auto-complete="on" name="place"></el-input>
      </el-form-item>
      <el-form-item prop="keyrord"   style="width: 100%;" label="关键词">
        <el-input placeholder="请输入" v-model="form.keyrord" auto-complete="on" name="keyrord"></el-input>
        <i id="keywordtitle" class="el-icon-warning" style="font-size: xx-small;color: gainsboro;margin-top: 5px;">{{keywordtitle}}</i>
      </el-form-item>

      <el-form-item prop="categoryid" style="width: 100%;" label="图片分类">
        <el-tree ref="menuTree" :data="data"  v-model="form.categoryid" node-key="id" :props="defaultProps" @node-click="handleNodeClick" highlight-current />
      </el-form-item>

      <el-form-item prop="VAttachmentContent" style="width: 100%;height: 9em;" label="简介">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 5}" v-model="form.VAttachmentContent" auto-complete="on" name="VAttachmentContent"></el-input>
      </el-form-item>

<!--      <el-form-item style="margin-right: 0.3rem;" label="是否收费">
        <el-radio-group v-model="form.VIsFree" @change="dialog">
          <el-radio  :label="0">免费</el-radio>
          <el-radio  :label="1">收费</el-radio>
        </el-radio-group>
        <el-popover
          placement="right-end"
          width="500"
          v-model="visible">
          <p>是否同意对平台免费开放非商业用途？</p>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="visible = false">同意</el-button>
            <el-button type="primary" size="mini" @click="visible = false">不同意</el-button>
          </div>
        </el-popover>
      </el-form-item>
      <el-form-item label-width="70px" label="定价" v-show="showPrice">
        <el-input placeholder="元" v-model="form.IPrice"></el-input>
      </el-form-item>
-->

      <div class="title" style="text-align: center;">附件提交</div>
      <el-form-item  prop="oldRemotePath" style="width: 100%;" label="上传原图">
<!--        <el-upload
          ref="uploadRef"
          accept=".png,.jpg,.jpeg,.jpeg,.tif"
          :action="imgUrlAction"
          action="string"
          list-type="picture-card"
          :auto-upload="true"
          :limit="1"
          :on-change="picHandleChange"
          :before-remove="beforeremove"
          :before-upload="beforeupload"
          :on-success="handleAvatarSuccess">
          <template #tip>
            &lt;!&ndash; 支持异步加载图片的组件 &ndash;&gt;
            <img class="el-upload-list__item-thumbnail" style="display: none" :src="form.vattachmentRemotePath" alt="图片为空" />
          </template>
          <i slot="default" class="el-icon-plus"/>
        </el-upload>-->
        <el-upload
          ref="uploadRef"
          accept=".png,.jpg,.jpeg,.tif"
          :action="imgUrlAction"
          list-type="picture-card"
          :auto-upload="true"
          :limit="1"
          :file-list="imgList"
          :before-upload="beforeUpload"
          :on-change="handleChange"
          :on-success="handleSuccess"
          :on-error="handleError"
          :on-progress="handleProgress"
          :before-remove="beforeRemove"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
        <!-- 进度条 -->
        <el-progress
          v-if="uploading"
          :percentage="progressPercent"
          status="success"
          style="margin-top: 20px"
        ></el-progress>
      </el-form-item>


    </el-form>


    <!-- 上传 -->
    <div class="author">
      <el-button @click="onUploadRes()" type="primary" style="margin: 0 auto;">上传</el-button>
      <el-button @click="onCancel()" type="primary" style="margin: 0 auto;">取消</el-button>
    </div>


  </div>
</template>

<script>
import {jump, getUser} from "../../../../untils/auth.js";
import Tiff from 'tiff.js'
export default {
  name:'picUpload',
  data() {
    return {
      parentNode:[],
      form: {
        VAttachmentName: '',
        VAttachmentType: '1',
        auditStatus : 0,
        imgSource : 1,
        author: '',
        Filmlocations: '',
        place: '',
        keyrord: '',
        IProductPublic: '1',
        categoryid :'' ,
        // 提交的文件
        VAttachmentId: '',
        VAttachmentContent: '',
        oldRemotePath: '',
        vattachmentRemotePath: '',

        // VIsFree: '',
        IPrice: 0,
      },
      videoRules: {
        VAttachmentName: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        author: [{ required: true, message: '拍摄者不能为空', trigger: 'blur' }],
        keyrord: [{ required: true, message: '关键词不能为空', trigger: 'blur' }],
        categoryid: [{ required: true, message: '分类不能为空', trigger: 'blur' }],
        // fileInfo: [{ required: true, message: '上传图不能为空',trigger: 'blur' }],
        VAttachmentContent: [{ required: true, message: '简介不能为空', trigger: 'blur'}],
      },
      // 图片上传
      imgUrlAction: window.IPConfig.IP + '/uploadImageToDfs.do',
      imgList: [], // 已上传的文件列表
      uploading: false, // 是否正在上传
      progressPercent: 0, // 上传进度百分比

      data: [],
      defaultProps: {
        children: 'children',
        label: 'text',
      },
      breadList:[],
      // showPrice: false,
      // 气泡框
      visible: false,
      keywordtitle:'',
    }

  },
  created() {
    var VNickname = JSON.parse(getUser()).principal.VNickname
    this.form.author=VNickname

    // 学科分类
    this.getCategroy();

    this.axios.post(window.IPConfig.IP + "/tbConfig/getTBConfig.do?VKey=keywordtitle").then((res) => {
      if (res.status == 200) {
        if (res.data.status == 200) {
          if (res.data.obj.length) {
            this.keywordtitle =res.data.obj[0].remark
          }
        }
      }
    });
  },
  methods: {
    jump,


    // 文件上传前的钩子
    beforeUpload(file) {

      const isImage = /\.(png|jpg|jpeg|tif)$/i.test(file.name);
      // const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isImage) {
        this.$message.error('只能上传图片文件');
        return false;
      }
    /*  if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB');
        return false;
      }*/

      this.uploading = true;
      this.progressPercent = 0;
      let loading = this.$loading({
        lock: true, // 显示/隐藏--默认为false
        text: "正在上传文件中，请耐心等等......", //显示在加载图标下方的加载文案
        background: "rgba(0,0,0,0.6)", //遮罩层颜色
        spinner: "el-icon-loading", //自定义加载图标类名
      });
      return true;
    },
    // 文件状态改变时的钩子
    handleChange(file, fileList) {
      console.log('文件状态改变:', file, fileList);
      if(file.raw.type === 'image/tiff'){
        let fr = new FileReader();
        fr.onload = function (e){
          let image = new Tiff({buffer:e.target.result});
          file.url = image.toDataURL();
        }
        fr.readAsArrayBuffer(file.raw);
        this.$emit("changFile","fileList");
      }
      this.$emit("changeFile",fileList);
      if (this.form.VAttachmentName ==""){
        this.form.VAttachmentName=file.raw.name.substring(0, file.raw.name.lastIndexOf("."));
      }
      // 隐藏上传按钮
      this.$refs.uploadRef.$children[1].$el.style.display = 'none'
    },
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      this.$loading().close()
      console.log('上传成功:', response, file, fileList);
      this.uploading = false;
      this.progressPercent = 100;
      this.$message.success('上传成功');
      if (response.status == 200) {
        console.log(file.response.obj.vattachmentRemotePath)
        this.form.VAttachmentId = file.response.obj.vattachmentId;
        this.form.oldRemotePath = file.response.obj.oldRemotePath;
        this.form.vattachmentRemotePath = file.response.obj.vattachmentRemotePath;
      }else{
        this.$message({
          type: 'error',
          center: true,
          message: res.msg
        });
        const { uploadFiles } = this.$refs.uploadRef
        if (uploadFiles && uploadFiles.length) {
          uploadFiles.splice(uploadFiles.length - 1, 1)
        }
        this.$refs.uploadRef.$children[1].$el.style.display = 'block'
      }
    },
    // 文件上传失败时的钩子
    handleError(err, file, fileList) {
      this.uploading = false;
      this.$message.error('上传失败，请重试');
    },
    // 文件上传进度变化时的钩子
    handleProgress(event, file, fileList) {
      console.log('上传进度:', event.percent);
      this.progressPercent = Math.floor(event.percent);
    },
    // 删除文件前的钩子
    beforeRemove(file, fileList) {
      this.$refs.uploadRef.$children[1].$el.style.display = 'block'

      this.form.VAttachmentName ="";
      var ids = [];
      ids.push(this.form.VAttachmentId);
      this.axios.post(window.IPConfig.IP + '/tBAttachments/deleteById.do?ids='+ids.join(",")).then((response) => {
        if (response.status == 200) {
          if (response.data.status == 200) {
            console.log(response.data)
          }
        }
      })
    },

/*
    picHandleChange(file, fileList) {
      console.log(file.raw.name)
      // 判断是否是tif格式
      if(file.raw.type === 'image/tiff'){
        let fr = new FileReader();
        fr.onload = function (e){
          let image = new Tiff({buffer:e.target.result});
          file.url = image.toDataURL();
        }
        fr.readAsArrayBuffer(file.raw);
        this.$emit("changFile","fileList");
      }
      this.$emit("changeFile",fileList);
      if (this.form.VAttachmentName ==""){
        this.form.VAttachmentName=file.raw.name.substring(0, file.raw.name.lastIndexOf("."));
      }
      // 隐藏上传按钮
      this.$refs.uploadRef.$children[1].$el.style.display = 'none'
    },*/
/*
    beforeupload (file) {
      let loading = this.$loading({
        lock: true, // 显示/隐藏--默认为false
        text: "正在上传文件中，请耐心等等......", //显示在加载图标下方的加载文案
        background: "rgba(0,0,0,0.8)", //遮罩层颜色
        spinner: "el-icon-loading", //自定义加载图标类名
      });

      const { uploadFiles } = this.$refs.uploadRef
      if (uploadFiles && uploadFiles.length) {
        uploadFiles.splice(uploadFiles.length - 1, 1)
      }

    },*/

/*    beforeremove(file){
      this.$refs.uploadRef.$children[1].$el.style.display = 'block'

      this.form.VAttachmentName ="";
      var ids = [];
      ids.push(this.form.VAttachmentId);
      this.axios.post(window.IPConfig.IP + '/tBAttachments/deleteById.do?ids='+ids.join(",")).then((response) => {
        if (response.status == 200) {
          if (response.data.status == 200) {
            console.log(response.data)
          }
        }
      })


    },*/
    // 封面上传
/*    handleAvatarSuccess(res, file) {
      this.$loading().close()

      if (res.status == 200) {
        console.log(file.response.obj.vattachmentRemotePath)
        this.form.VAttachmentId = file.response.obj.vattachmentId;
        this.form.oldRemotePath = file.response.obj.oldRemotePath;
        this.form.vattachmentRemotePath = file.response.obj.vattachmentRemotePath;
      }else{
        this.$message({
          type: 'error',
          center: true,
          message: res.msg
        });
        const { uploadFiles } = this.$refs.uploadRef
        if (uploadFiles && uploadFiles.length) {
          uploadFiles.splice(uploadFiles.length - 1, 1)
        }
        this.$refs.uploadRef.$children[1].$el.style.display = 'block'
      }
    },*/

    // 上传
    onUploadRes() {


      this.$refs.videoForm.validate(valid => {
        if (valid) {
          var files = this.$refs.uploadRef.uploadFiles[0];
          if (files==undefined){
            this.$message({
              type: 'error',
              message: '上传图不能为空'
            });
            return false;
          }


          // var formData = new FormData();
          // formData.append('file', files.raw);
          // formData.append('VAttachmentId', this.form.VAttachmentId);
          // formData.append('VAttachmentName', this.form.VAttachmentName);
          // formData.append('Filmlocations', this.form.Filmlocations);
          // formData.append('VAttachmentType', 1);
          // formData.append('auditStatus', 0);
          // formData.append('imgSource', 1);
          // formData.append('IProductPublic', 1);
          // formData.append('author', this.form.author);
          // formData.append('keyrord', this.form.keyrord);
          // formData.append('VAttachmentContent', this.form.VAttachmentContent);
          // formData.append('place', this.form.place);
          // formData.append('categoryid', this.form.categoryid);
          // formData.append('createdBy', JSON.parse(getUser()).principal.VUserId);
          // formData.append('updateBy', JSON.parse(getUser()).principal.VUserId);
          // formData.append('imgCopyright', JSON.parse(getUser()).principal.VUserId);
          // formData.append('VSystemId', this.$store.state.user.VSystemId);
          // formData.append('IPrice', this.form.IPrice);
          // console.log(formData)

          let loading = this.$loading({
            lock: true, // 显示/隐藏--默认为false
            text: "正在处理中，请耐心等等......", //显示在加载图标下方的加载文案
            background: "rgba(0,0,0,0.8)", //遮罩层颜色
            spinner: "el-icon-loading", //自定义加载图标类名
          });
          this.form.VSystemId = this.$store.state.user.VSystemId;
          this.form.createdBy = JSON.parse(getUser()).principal.VUserId;
          this.form.updateBy =JSON.parse(getUser()).principal.VUserId;
          this.form.imgCopyright =JSON.parse(getUser()).principal.VUserId;
          this.axios.post(window.IPConfig.IP + '/tBAttachments/addImage.do', this.form).then((response) => {
            console.log(response)
              this.$loading().close();
            if (response.data.status == 200) {
              // _this.onUserInfo();
              this.$message({
                type: 'success',
                message: '更改成功'
              });
              // 跳转上传列表
              this.$router.push({path: '/education/personalcenter/mypicfile'});
            } else if (response.data.status == 601) {
              this.jump('/login')
            } else {
              this.$message({
                type: 'info',
                message: '已取消更改'
              })
            }
            this.disabled = true;
            this.text = '编辑信息'
          })
        }
      })
    },



    // 取消上传
    onCancel() {
      this.$router.push({
        path: '/education/personalcenter/mypicfile',
      })
    },


    getCategroy() {
      this.axios.post(window.IPConfig.IP + "/tBCategory/getTree3.do", {
        VSystemId: '2ef5ac97d1d259d06309b71838f4e766',
        VModulerId: 'fcface19b4ae482581d7a5a403e72331'
      }).then((res) => {
        this.data = res.data.obj || [];

        this.form.categoryid = this.data[0].id;
        let targetNodeKey = this.form.categoryid;
        this.$nextTick(() => {
          //判断是否存在指定节点
          if (this.$refs.menuTree.getNode(targetNodeKey)) {
            //若存在指定节点，则设置当前节点为指定节点（用于高亮显示当前节点）
            this.$refs.menuTree.setCurrentKey(targetNodeKey)
            //展开指定节点
            this.$refs.menuTree.store.nodesMap[targetNodeKey].expanded = true;
            var selected = this.$refs.menuTree.getCurrentNode();
            if (this.$refs.menuTree.getNode(selected) && this.$refs.menuTree.getNode(selected).parent) {
              this.expandParents(this.$refs.menuTree.getNode(selected).parent)
            }
          } else {
            //若不存在指定节点，则设置当前节点为null（清除当前节点的高亮效果）
            this.$refs.menuTree.setCurrentKey()
          }
        })
      });
    },
// 展开所有祖宗节点
    expandParents(node) {
      node.expanded = true
      if (node.parent) {
        this.expandParents(node.parent)
      }
    },

    handleNodeClick() {
      let node = this.$refs.menuTree.getCurrentNode();
      console.log(node)
      this.form.categoryid = node.id;
    },

    // 收费提示价钱
    /*dialog(val) {
      console.log(val);
      if(val == 1){
        this.visible = true;
        this.showPrice = true;
      }else{
        this.showPrice = false;
        this.visible = false;
      }
    },*/
  }
}
</script>

<style lang="stylus" scoped>

.container {
  padding 0.3rem
  border: 0.01rem solid #ccc

}
.title {
  font-size: 0.26rem;
  margin-bottom: 30px;
  font-weight: 500;
}
.author{
  width: 100%;
  text-align: center;
}
// 弹出框协议内容
.argummentTitle{
  width: 100%;
  text-align: center;
  font-size: .3rem;
  font-weight: 700;
}
.okBtn{
  position: absolute;
  bottom: .1rem;
  right: .5rem;
}
//  .el-dialog__body{
//     height: 4rem;
//     overflow-y: scroll;
//  }
.argumentCon{
  text-indent: 2em;
  line-height: 2;
  height: 4rem;
  overflow-y: scroll;
}
.el-dialog{
  margin-top:0 !important;
}

.ApplyForm {
  width: 60%;
}
.ApplyForm .Apply_title {
  text-align: center;
  font-size: 0.24rem;
  font-weight: bold;
  margin: 0 0 0.3rem;
}
.ApplyBox .ApplyForm .el-upload--picture-card {
  width: 0.8rem;
  height: 0.8rem;
  line-height: 0.8rem;
}
.ApplyBox .ApplyForm .el-upload-list--picture-card .el-upload-list__item {
  width: 0.8rem;
  height: 0.8rem;
}



.el-input {
  display: inline-block;

  input {
    background-color: transparent;
    border: 0px;
    -webkit-appearance: none;
    border-radius: 0px;
    padding: 12px 5px 12px 15px;
    color: $light_gray;
    height: 47px;
    caret-color: $cursor;

    &:-webkit-autofill {
      box-shadow: 0 0 0px 1000px #f8f9fa inset !important;
      -webkit-text-fill-color: $cursor !important;
    }
  }
}



</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/picUpload.vue